import React, { FC } from 'react';
import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import { ReturnDeliveryInfo } from 'typings/returns';
import useI18n from '../../../../i18n/hooks/useI18n';
import HeaderValueList from '../../../../commons/components/HeaderValueList';
import makePrice from '../../utils/makePrice';

import styled from '../../../../theme/styled';

const InfoContainer = styled.div`
  padding: ${({ theme }) => theme.space[12]} 0;
`;

interface SellerPaymentDetailsProps {
  deliveryDetails: ReturnDeliveryInfo;
}

const SellerPaymentDetails: FC<SellerPaymentDetailsProps> = ({ deliveryDetails }) => {
  const i18n = useI18n();
  const price = makePrice('pl-PL');
  const listItems = deliveryDetails.fee && [
    {
      header: i18n('dlv_returns_details_payment_details_order_seller_fee'),
      value: price.parseAndFormat(deliveryDetails.fee.amount, deliveryDetails.fee.currency),
      isImportant: true,
    },
  ];

  return (
    <>
      {deliveryDetails.fee ? (
        <HeaderValueList listItems={listItems} />
      ) : (
        <InfoContainer>
          <Paragraph4>{i18n`dlv_returns_details_payment_details_order_seller_no_confirmed_seller`}</Paragraph4>
        </InfoContainer>
      )}
    </>
  );
};

export default SellerPaymentDetails;
